(function(){
  var body=document.body;
  if(!body)return;

  var topLayer=null;
  var styleTag=null;

  function getModal(){
    return document.getElementById('nailura-color-compare');
  }

  function ensureStyle(){
    if(styleTag)return;
    styleTag=document.createElement('style');
    styleTag.id='nailura-color-top-layer-style';
    styleTag.textContent='#nailura-color-top-layer{position:fixed!important;inset:0!important;width:100vw!important;height:100vh!important;max-width:none!important;max-height:none!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;overflow:visible!important}#nailura-color-top-layer::backdrop{background:transparent!important}';
    document.head.appendChild(styleTag);
  }

  function ensureTopLayer(){
    var modal=getModal();
    if(!modal)return;

    ensureStyle();

    topLayer=document.getElementById('nailura-color-top-layer');
    if(!topLayer){
      topLayer=document.createElement('dialog');
      topLayer.id='nailura-color-top-layer';
      topLayer.setAttribute('aria-label','Farvesammenligning');
      document.body.appendChild(topLayer);

      topLayer.addEventListener('cancel',function(event){
        event.preventDefault();
        var closeButton=modal.querySelector('.nailura-color-modal__close');
        if(closeButton)closeButton.click();
      });
    }

    if(modal.parentElement!==topLayer)topLayer.appendChild(modal);

    if(!topLayer.open){
      try{topLayer.showModal();}
      catch(e){topLayer.setAttribute('open','');}
    }
  }

  function closeTopLayer(){
    topLayer=document.getElementById('nailura-color-top-layer');
    if(!topLayer)return;
    if(topLayer.open){
      try{topLayer.close();}
      catch(e){topLayer.removeAttribute('open');}
    }
  }

  var observer=new MutationObserver(function(){
    if(body.classList.contains('nailura-color-modal-open')){
      ensureTopLayer();
    }else{
      closeTopLayer();
    }
  });

  observer.observe(body,{attributes:true,attributeFilter:['class']});

  document.addEventListener('click',function(){
    if(body.classList.contains('nailura-color-modal-open')){
      requestAnimationFrame(ensureTopLayer);
    }
  },true);

  if(body.classList.contains('nailura-color-modal-open'))ensureTopLayer();
})();